jQuery(document).ready(function ($) {


    const amountLocationItemsLength = $('.c-location-cards__single').length;

    let displayPerButton = 30
    let currentMax = 31
    let previousMax = 1


    $('.btn-show-more').click(function () {
        currentMax += displayPerButton
        previousMax += displayPerButton
        let i = previousMax

        while (i < currentMax) {
            $(".c-location-cards__single:nth-child(" + i + ")").show()
            i++;
        }

        if (currentMax + 30 > amountLocationItemsLength) {
            $('.btn-show-more').fadeOut();
        }

    })


    var map;
    var geocoder;
    var service;
    var userLocation;
    var userMarker;
    var markers = [];
    var markersFull = [];
    var stores = [];
    var locationsLoaded = 0;
    var searchLocationsCount = 0;
    var totalLocations;
    var snazzyStyle = [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#444444"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f2f2f2"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#ff0000"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": "100"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "lightness": "100"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape.natural.landcover",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": "100"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "off"
                },
                {
                    "lightness": "23"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 45
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffd900"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#ffd900"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#cccccc"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];
    var search = false;
    var defLat = 52.09083;
    var defLeng = 5.12222;

    function initMap() {
        geocoder = new google.maps.Geocoder();

        var zoom = 8;

        var clusterStyles = {
            styles: [{
                textColor: '#FDC300',
                textSize: 12,
                url: ajax_object.siteurl + '/assets/images/cluster.png',
                width: 65,
                height: 65,
            }]
        };

        map = new GMaps({
            el: '#map',
            lat: defLat,
            lng: defLeng,
            zoom: zoom,
            minZoom: 4,
            scrollwheel: false,
            styles: snazzyStyle,
            disableDefaultUI: true,
            zoomControl: true,


            markerClusterer: function (map) {
                var markerClusterer = new MarkerClusterer(map, [], clusterStyles, {});

                if (search == true) {
                    markerClusterer.setMap(null);
                }

                return markerClusterer;
            }

        });

        setMarkers(map);
        center_map(map);


        $('.js-location').on('click', function () {

            const number = $(this).index();

            map.setZoom(16);

            map.setCenter({
                lat : map.markers[number].getPosition().lat(),
                lng : map.markers[number].getPosition().lng()
            });


            $.each(map.markers, function (i) {
                map.markers[i].infoWindow.close(map, map.markers[i]);
            });

            map.markers[number].infoWindow.open(map, map.markers[number]);

        })

    }

    function setUserLocation(latitude, longitude) {
        userLocation = {
            lat: latitude,
            lng: longitude
        };

        if (userMarker) {
            userMarker.setPosition(userLocation);
        } else {
            userMarker = map.addMarker({
                lat: latitude,
                lng: longitude
            });
        }

        map.setCenter(latitude, longitude);
    }

    function center_map(map) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {

            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            google.maps.event.addListener(marker, "click", function () {
                jQuery('.gm-style-iw').prev('div').remove();
            });

            bounds.extend(latlng);

        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }

    }


    /*function getDistance(latitude, longitude, store) {

     service = new google.maps.DistanceMatrixService();
     service.getDistanceMatrix({
     origins: [{lat: latitude, lng: longitude}],
     destinations: [{lat: parseFloat(store.location_lat_long.lat), lng: parseFloat(store.location_lat_long.lng)}],
     travelMode: 'DRIVING'
     }, function(response, status) {

     console.log(status);

     if(response) {
     var distance = response.rows[0].elements[0].distance;
     appendDistanceLabel(store, distance);
     } else {
     locationsLoaded++;
     console.log('distance for location (' + store.location_id + ') empty');
     }
     });
     }*/


    function setMarkers(map) {
        var marker;

        for (var index in locations) {
            var m = locations[index];
            stores[m.location_id] = m;

            if (m.location_lat_long && m.location_lat_long.lat && m.location_lat_long.lng) {

                var html = '<section class="stores">';
                html += '<article class="location-item" data-id="' + m.location_id + '">';

                html += '<h3>' + m.location_title + '</h3>';

                html += '<ul>';
                html += '<li>' + m.location_street + ' ' + m.location_number + '</li>';
                html += '<li>' + m.location_zipcode + ' ' + m.location_city + '</li>';
                html += '</ul>';

                html += '<div class="contact-data">';

                if (m.location_website) {
                    let website_url = m.location_website;

                    if(m.location_website.indexOf('https') === -1 || m.location_website.indexOf('http') === -1){
                        website_url = 'https://' + m.location_website;
                    }

                    html += '<div class="new-site"><a href="' + website_url + '" target="_blank">' + m.location_website + '</a></div>';
                }
                if (m.location_email) {
                    html += '<div class="email"><a href="mailto:' + m.location_email + '">' + m.location_email + '</a></div>';
                }

                if (m.location_visible_phone) {
                    html += '<div class="tel"><a href="tel:' + m.location_visible_phone + '">' + m.location_visible_phone + '</a></div>';
                }

                if (m.location_lat_long) {
                    var routeUrl = 'https://maps.google.com?saddr=Current+Location&daddr=' + m.location_lat_long['lat'] + ', ' + m.location_lat_long['lng'];
                    html += '<div class="new-site"><a href="' + routeUrl + '" target="_blank">' + 'Route' + '</a></div>';
                }
                html += '</div>';

                html += '</article>';
                html += '</section>';

                var imgURL = templateDirectory + '/assets/images/marker.png';
                var image = {
                    url: imgURL
                };

                var args = {
                    icon: image,
                    lat: m.location_lat_long.lat,
                    lng: m.location_lat_long.lng,
                    infoWindow: {
                        content: html
                    }
                };

                marker = map.addMarker(args);
                markersFull.push(marker);
                markers[m.location_id] = marker;

            } else {
                console.log('location (' + index + ') missing long/lat');
            }
        }
    }

    if ($('#map').length) {

        initMap();
    }

    if ($('.total-locations').length) {
        countLocations()
    }


});
